import {Customer} from '../../Entities/Customer'
import {MessageWithTranslation} from '../../Entities/MessageWithTranslation.entity.evolve'
import {ProductShippingService} from '../../Entities/ProductShippingService'

export interface ProductCalculationImportState {
    readonly csvUploadStatus: CsvUploadStatus
    readonly showFormular: boolean
    readonly createMessageModal: CreateMessageModal
    readonly availableShippingServices: ProductShippingService[]
    readonly availableCustomers: Customer[]
    readonly form: ProductCalculationImportFormular
    readonly attemptedShowFormular: boolean
    readonly attemptingToSave: boolean
}

export type CsvUploadStatus =
    CsvUploadStatusNone
    | CsvUploadStatusSuccess
    | CsvUploadStatusError

export interface CsvUploadStatusSuccess {
    readonly type: 'Success'
    readonly value: string[][]
}
export interface CsvUploadStatusError {
    readonly type: 'Error'
    readonly reason: string
}
export interface CsvUploadStatusNone {
    readonly type: 'None'
}

export interface CreateMessageModal {
    open: boolean
    key: string
    saving: null | string
    type: CreateMessageModalInput
    format: CreateMessageModalInput
    coverage: CreateMessageModalInput
    print: CreateMessageModalInput
    paper: CreateMessageModalInput
    processing: CreateMessageModalInput
}

export interface CreateMessageModalInput {
    needCreation: boolean
    submissionAttempted: boolean
    text: string
    textValidation: 'Mandatory' | null
    translation: string
    translationValidation: 'Mandatory' | null
}
export function createCreateMessageModalInput(): CreateMessageModalInput {
    return {
        needCreation: false,
        submissionAttempted: false,
        text: '',
        textValidation: null,
        translation: '',
        translationValidation: null
    }
}

export interface ProductCalculationImportFormular {
    submissionAttempted: boolean
    type: ProductCalculationAttribute
    format: ProductCalculationAttribute
    coverage: ProductCalculationAttribute
    print: ProductCalculationAttribute
    paper: ProductCalculationAttribute
    processing: ProductCalculationAttribute
    weight: string
    weightValidation: 'Mandatory' | 'InvalidInt' | null
    selectedShippingServiceId: number | null
    selectedShippingServiceValidation: 'Mandatory' | null
    selectedCustomers: Customer[],
    priceList: ProductCalculationPriceRow[]
}

export interface ProductCalculationAttribute {
    readonly input: string
    readonly value: number
    readonly suggestions: MessageWithTranslation[]
    readonly wasRecentlyCreated: boolean
}

export interface ProductCalculationPriceRow {
    readonly minQuantity: string
    readonly minQuantityValidation: 'Mandatory' | 'InvalidInt' | 'NotUniqueInArray' | null
    readonly price: string
    readonly priceValidation: 'Mandatory' | 'InvalidFixedPointNumber' | null
}

export function createProductCalculationAttribute(
    defaultInput: string = '',
    defaultValue: number = 0
): ProductCalculationAttribute {
    return {
        input: defaultInput,
        value: defaultValue,
        suggestions: [],
        wasRecentlyCreated: false,
    }
}

export function createEmptyForm(): ProductCalculationImportFormular {
    return {
        submissionAttempted: false,
        type: createProductCalculationAttribute(),
        format: createProductCalculationAttribute(),
        coverage: createProductCalculationAttribute(),
        print: createProductCalculationAttribute(),
        paper: createProductCalculationAttribute(),
        processing: createProductCalculationAttribute(),
        weight: '',
        weightValidation: null,
        selectedShippingServiceId: 1,
        selectedShippingServiceValidation: null,
        selectedCustomers: [],
        priceList: [
            {
                minQuantity: '1',
                minQuantityValidation: null,
                price: '',
                priceValidation: null,
            }
        ]
    }
}

export interface MultiSelectObject {
    id: number,
    name: string
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/ProductCalculationImport/ProductCalculationImportState.ts